var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":`tel:${_vm.telNumber ? _vm.telNumber : '02038460003'}`},on:{"click":function($event){return _vm.customEvent('Dealer Locator', 'Phone number', 'Clicked')}}},[_vm._v("\n    "+_vm._s(_vm.displayNumber ? _vm.displayNumber : _vm.telNumber ? _vm.telNumber : '024 7685 1458')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }